// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-bade-block i[data-v-71544468] {\n  font-size: 3rem;\n}\n", ""]);
// Exports
module.exports = exports;
